import React from "react";

// font awesome
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function UploadButton({ onToggleUpload }) {
  return (
    <span className="upload-icon-btn" onClick={onToggleUpload}>
      <FontAwesomeIcon icon={faUpload} />
    </span>
  );
}
